import React from "react";
import { GetStaticProps } from "next";
import { Util } from "@xt/xtbase";
const { getOrigin } = Util;
import { get_tdk } from "api/server/tdk";

import Layout from "components/Layout";
import Main from "components/Pages/Listing";

interface Props {
    tdk?: any;
    resolvedUrl: string;
}

const AboutUsPage: React.FC<Props> = () => {
    return (
        <Layout>
            <Main />
        </Layout>
    );
};

export default AboutUsPage;

export const getStaticProps: GetStaticProps = async (context) => {
    const resolvedUrl = "/aboutUs";
    const props: Props = { resolvedUrl };

    try {
        const tdkUrl = getOrigin("www") + "/" + context.locale + resolvedUrl;
        const tdk = await get_tdk({
            params: {
                url: tdkUrl,
                languageType:
                    context.locale == "zh-CN"
                        ? "cn"
                        : context.locale == "zh-HK"
                            ? "hk"
                            : context.locale,
            },
        });
        props.tdk = tdk || {};
    } catch (error) {
        console.log("get tdk error");
        console.log(error);
        props.tdk = {};
    }

    return {
        props,
        revalidate: 60,
    };
};
